import { TranslationKeys } from 'app/translations';

export const EmployeeEmploymentContractFields = {
  StartDate: {
    Label: TranslationKeys.employees_detail_contract_startDate,
    InputName: 'startDate',
    Options: {
      style: 'date',
    },
  },
  EndDate: {
    Label: TranslationKeys.employees_detail_contract_endDate,
    InputName: 'endDate',
    Options: {
      style: 'date',
    },
  },
  ContractType: {
    Label: TranslationKeys.employees_detail_contractType,
    InputName: 'contractType',
  },
  ContractId: {
    Label: TranslationKeys.employees_detail_contract_id,
    InputName: 'contractId',
  },
  CreationDate: {
    Label: TranslationKeys.global_creationDate,
    InputName: 'creationDate',
    Options: {
      style: 'date',
    },
  },
  EmploymentSequence: {
    Label: TranslationKeys.global_sequence,
    InputName: 'employmentSequence',
  },
};
